/* eslint-disable react/checked-requires-onchange-or-readonly */
/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { object, number } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useOpcionais } from '../../contexts/OpcionaisContext'
import { useGlobal } from '../../contexts/GlobalContext'
import { METODO_PAGAMENTO_PIX } from '../../constants'
import { DESCRICAO_PIX_PENDENTE, LABEL_OPCIONAL_COMPRADO } from './constantsCardOpcionais'
import { formatValor } from '../../utils/formatter/formatter'
import { isEmptyObject } from '../../utils/helpers/helpers'
import { contarOpcionaisComprados } from '../../utils/helpers/helpersOpcionais'
import { ReactComponent as KitPassadoLaranja } from '../../assets/icons/kitpassadoLaranja.svg'
import { ReactComponent as KitPassadoAzul } from '../../assets/icons/kitpassadoAzul.svg'
import { ReactComponent as EsgotadoLaranja } from '../../assets/icons/esgotadoLaranja.svg'
import { ReactComponent as EsgotadoAzul } from '../../assets/icons/esgotadoAzul.svg'

const estiloCardSelecionado = `
  transition: 0.3s;
`

const hoverOpcional = `
  cursor: pointer;
  &:hover {
    ${estiloCardSelecionado}
  }
`

const estiloCardComprado = `
  filter: gray;
  filter: grayscale(100%);
`

const mouseOpcionalBloqueado = `
  &:hover {
    cursor: not-allowed;
  }
`

const Item = styled.div`
  padding-top: ${( { isKitPassado } ) => ( isKitPassado ? '32px' : '16px' )};
  .control {
    ${( { podeComprar } ) => ( podeComprar ? 'position: relative;' : 'display: none' )};
    padding-left: 30px;
    margin-bottom: 5px;
    padding-top: 3px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    color: #343a4f;
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 12px;
    }
  }
  .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control_indicator {
    position: absolute;
    top: 2px;
    left: 0;
    height: 20px;
    width: 20px;
    background: #ffffff;
    border: 1px solid #21c5e5;
    ${( { podeComprar } ) => ( podeComprar ? '' : 'border-color: #343A4F; display: none' )}
    border-radius: 3px;
  }
  .control input:checked ~ .control_indicator {
    background: #21c5e5;
  }

  .control input:disabled ~ .control_indicator {
    background: #e6e6e6;
    opacity: 0.6;
    pointer-events: none;
  }
  .control_indicator:after {
    box-sizing: unset;
    content: "";
    position: absolute;
    display: none;
  }
  .control input:checked ~ .control_indicator:after {
    display: block;
  }
  .control-checkbox .control_indicator:after {
    left: 7px;
    top: 3px;
    width: 3px;
    height: 8px;
    border: solid #ffffff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  .control-checkbox input:disabled ~ .control_indicator:after {
    border-color: #7b7b7b;
  }

  .wrapper-item-opcional {
    display: flex;
    height: 100%;
    width: 100%;
    border: 2px solid
      ${( { isSelecionado } ) => ( isSelecionado ? ' #21c5e5;' : 'white' )};
    box-shadow: 0px 1px 4px rgba(19, 26, 45, 0.2);
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 30px;
    position: relative;

    @media (max-width: 320px) {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    svg {
      position: absolute;
      left: 0;
      top: 0;
      left: 16px;
      top: -16px;
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      cursor: pointer;
      ${( { podeComprar } ) => !podeComprar && mouseOpcionalBloqueado}
    }
  }

  .imagem-opcional {
    flex: 1;
    align-items: center;
    align-self: center;

    border: 1px solid transparent;
    display: flex;
    justify-content: center;
    object-fit: cover;
    transition: 0.3s;

    @media (max-width: 300px) {
      width: 60px;
    }

    ${( { podeComprar } ) => ( podeComprar ? hoverOpcional : estiloCardComprado )}
    ${( { isSelecionado } ) => isSelecionado && estiloCardSelecionado}

    img {
      border-radius: 10px;
      width: 100%;
    }
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      img {
        padding-top: 10px;
        width: 109px;
        height: auto;
      }
    }
  }

  .conteudo-opcional {
    display: flex;
    flex: 1;
    padding-left: 20px;
    flex-direction: column;
    justify-content: space-around;

    h3 {
      width: 100%;
      margin-bottom: 5px;
      font-weight: 600 !important;
      font-size: 13px;
      color: #343a4f;
    }

    &:hover {
      .imagem-opcional {
        ${estiloCardSelecionado}
      }
    }

    .titulo-valor-opcional {
      ${( { podeComprar } ) => podeComprar && `color: ${StyleGuide.cores.azul}`};
      font-size: 25px;
      padding-bottom: 10px;

      @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
        font-size: 18px;
        padding-bottom: 15px;
      }
    }

    .titulo-valor-original-opcional {
      color: ${StyleGuide.cores.cinza300};
      font-size: 15px;
      text-decoration: line-through;

      @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
        font-size: 10px;
      }
    }

    .titulo-opcional-adquirido {
      color: ${StyleGuide.cores.cinza500};
      font-size: 25px;
      padding-bottom: 10px;
      text-transform: uppercase;

      @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
        font-size: 18px;
        padding-bottom: 15px;
      }
    }
  }

  .bloqueado-opcional {
    margin-top: 20px;

    h5 {
      color: ${StyleGuide.cores.cinza400};
      font-size: 13px;
      line-height: 1.25;
      margin-bottom: 15px;
      min-width: 120px;
      margin-top: -10px;

      @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
        margin-bottom: 5px;
      }
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-bottom: 15px;
    }
  }
`

const EsgotadoAzulStyled = styled( EsgotadoAzul )`
  position: unset !important;
`

const EsgotadoLaranjaStyled = styled( EsgotadoLaranja )`
  position: unset !important;
`

const BoxOpcionais = ( { opcional, 'index': numeroProduto } ) => {
  const {
    dadosOpcionais,
    opcionaisSelecionados,
    setOpcionalSelecionado
  } = useOpcionais()
  const { modalidadesDaAssinatura } = useGlobal()
  const [ isOpcionalSelecionado, setIsOpcionalSelecionado ] = useState( false )
  const [ podeComprar, setPodeComprar ] = useState( false )
  const [ isExpanded, setIsExpanded ] = useState( false )

  const handleClick = () => {
    setIsExpanded( !isExpanded )
  }

  useEffect( () => {
    if ( opcionaisSelecionados ) {
      const isSelecionado = opcionaisSelecionados.find( opcionalSelecionado => opcionalSelecionado.id === opcional.id )
      setIsOpcionalSelecionado( Boolean( isSelecionado ) )
    }
  }, [ opcionaisSelecionados ] )

  useEffect( () => {
    const qtdeOpcionaisComprados = contarOpcionaisComprados( dadosOpcionais.opcionais.produtos )
    if ( qtdeOpcionaisComprados >= 3 || !opcional.ativo ) {
      setPodeComprar( false )
    } else if ( modalidadesDaAssinatura && modalidadesDaAssinatura.length && !isEmptyObject( opcional ) ) {
      setPodeComprar( opcional.vendas.length === 0 )
    }
  }, [ modalidadesDaAssinatura, opcional, dadosOpcionais ] )

  const onClickOpcional = opcionalClicado => {
    if ( opcionaisSelecionados.includes( opcionalClicado ) ) {
      const opcoes = opcionaisSelecionados.filter( opcionalNaoClicado => opcionalNaoClicado.id !== opcionalClicado.id )
      setOpcionalSelecionado( opcoes )
    } else if ( podeComprar ) {
      const selecionados = opcionaisSelecionados.concat( opcionalClicado )
      const qtdeOpcionaisComprados = contarOpcionaisComprados( dadosOpcionais.opcionais.produtos )
      if ( opcionaisSelecionados.length + qtdeOpcionaisComprados >= dadosOpcionais.limitePorUsuario ) {
        selecionados.shift()
      }
      setOpcionalSelecionado( selecionados )
    }
  }
  const displayInfoCompra = ( opcionalAtivo ) => {
    const { formaPagamento } = dadosOpcionais
    if ( formaPagamento !== METODO_PAGAMENTO_PIX.visualizacao ) {
      return null
    }
    const temPixPendente = ( opcionalAtivo.vendas || [] ).some( venda => {
      return venda.dadosPix && !venda.dadosPix.pixFoiPago && venda.dadosPix.urlQrCode
    } )
    if ( temPixPendente ) {
      return <h5>{ DESCRICAO_PIX_PENDENTE }</h5>
    }
    return null
  }

  function kitPassado() {
    if ( opcional.categoriaId === 1 ) {
      return <KitPassadoAzul />
    }
    if ( opcional.categoriaId === 2 ) {
      return <KitPassadoLaranja />
    }
  }

  function esgotado() {
    if ( opcional.categoriaId === 1 ) {
      return <EsgotadoAzulStyled />
    }
    if ( opcional.categoriaId === 2 ) {
      return <EsgotadoLaranjaStyled />
    }
  }

  const jaComprado = Boolean( opcional.vendas && opcional.vendas.length )

  return (
    <Item
      curadoria={ opcional.categoriaId === 1 }
      isKitPassado={ Boolean( opcional.isKitPassado ) }
      isSelecionado={ isOpcionalSelecionado }
      key={ `opcional-${opcional}` }
      podeComprar={ podeComprar }
    >
      <div className="wrapper-item-opcional">
        {Boolean( opcional.isKitPassado ) && kitPassado()}

        <div className="imagem-opcional">
          <img
            alt="foto-opcional"
            className={ `imagem-produto-${numeroProduto}` }
            onClick={ handleClick }
            src={ opcional.imagem }
          />
          {isExpanded ?
            <div
              onClick={ handleClick }
              style={{
                'position': 'fixed',
                'top': 0,
                'left': 0,
                'width': '100%',
                'height': '100%',
                'backgroundColor': 'rgba(0, 0, 0, 0.5)',
                'display': 'flex',
                'justifyContent': 'center',
                'alignItems': 'center',
                'zIndex': 9999,
              }}
            >
              <img
                alt="foto-opcional-maior"
                src={ opcional.imagem }
                style={{ 'width': '80%', 'height': '80%', 'objectFit': 'contain' }}
              />
            </div> : null}
        </div>

        <div className="conteudo-opcional">
          <h3>{opcional.descricao}</h3>

          <div className="flex-to-bottom">
            {jaComprado ? (
              <h3 className="titulo-opcional-adquirido">
                {LABEL_OPCIONAL_COMPRADO}
              </h3>
            ) : (
              <>
                {opcional.precoOriginal ? (
                  <h4 className="titulo-valor-original-opcional">
                    {formatValor( { 'valor': opcional.precoOriginal } )}
                  </h4>
                ) : null}

                <h3 className="titulo-valor-opcional">
                  {formatValor( { 'valor': opcional.preco } )}
                </h3>
              </>
            )}

            <div className="control-group">
              <label className="control control-checkbox">
                <input
                  checked={ isOpcionalSelecionado }
                  onClick={ () => onClickOpcional( opcional ) }
                  type="checkbox"
                />
                EU QUERO!

                <div className="control_indicator" />
              </label>
            </div>
          </div>

          {!StyleGuide.isMobile() && !podeComprar && (
            <div className="bloqueado-opcional">
              {!podeComprar && displayInfoCompra( opcional )}
            </div>
          )}

          {Boolean( !opcional.ativo ) && esgotado()}
        </div>
      </div>

      {StyleGuide.isMobile() && (
        <div className="bloqueado-opcional">
          {!podeComprar && displayInfoCompra( opcional )}
        </div>
      )}
    </Item>
  )
}

BoxOpcionais.propTypes = {
  'index': number.isRequired,
  'opcional': object.isRequired
}

export default BoxOpcionais
